import { useMemo } from 'react';
import { getMtaAccessConfig } from './get-mta-access-config';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';

/**
 * Hook to determine the access configuration for the MTA journey.

 * @returns An object containing:
 * - `permitted`: Boolean indicating if the user can access the MTA journey
 * - `helper`: Object with display logic for blocked access reasons
 *
 */
export const useMtaAccessConfig = () => {
	const policy = useAppSelector((state) => state.fullPolicy);
	// Priority 1 - Check if the policy is active to begin with
	const activePolicy = !!policy.isActive; // presently we check this in policy details to hide the button, but the hook won't count on this
	// Priority 2 - Check if MTAs are switched on
	const mtaEnvEnabled = import.meta.env.VITE_MTA_ENABLED !== 'false';
	// Priority 3 - Check policy eligibility for change
	const mtaEligibility = !!policy.mtaEligibility?.isEligible;
	const mtaIneligibilityReason = policy.mtaEligibility?.mtaIneligibilityReason;

	const mtaAccessConfig = useMemo(
		() => getMtaAccessConfig(activePolicy, mtaEligibility, mtaIneligibilityReason, mtaEnvEnabled),
		[activePolicy, mtaEligibility, mtaIneligibilityReason, mtaEnvEnabled],
	);

	return mtaAccessConfig;
};
